<template>
  <div>
    <Privacy />
  </div>
</template>

<style scoped>
body {margin:10px;padding:10px}
</style>

<script>
import Privacy from '@/components/core/privacy.vue'
export default {
  name: 'DirectoryAdmin',
  components: {
    Privacy
  },
  mounted () {
    console.log('created privacy ')
  }
}
</script>
